import { render, staticRenderFns } from "./HistoricalTable.vue?vue&type=template&id=5f72ef2e&"
import script from "./HistoricalTable.vue?vue&type=script&lang=js&"
export * from "./HistoricalTable.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HistoricalTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports